/* eslint-disable no-underscore-dangle */
import React from "react";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

import chameleon from "@chamaeleonidae/chmln";

const PH_PREFIX = {
  USER: "user::"
};

function ConfigureAnalytics({ children, user, orgDetails, eventDetails }) {
  /* chameleon.io user identification and data */

  const posthog = usePostHog();
  const userId = `${PH_PREFIX.USER}${window.__ENV__}::${user.id}`;
  const orgId = eventDetails.org_id || orgDetails.id;
  const orgName = eventDetails.org_name || orgDetails.name;
  const currentOrgId = orgId ? orgId : null;
  const currentEventId = eventDetails?.id ? eventDetails.id : null;
  const isEventAdmin =
    currentEventId &&
    user?.event_roles?.some(r => r.is_admin && r.event_id === currentEventId)
      ? true
      : false;

  useEffect(() => {
    if (
      // user is logged in
      user?.id &&
      // is viewing org or event
      (currentOrgId || currentEventId) &&
      // is viewing org admin or (is viewing event and is event admin)
      (orgDetails?.id || isEventAdmin)
    ) {
      if (!window.chmln) {
        // @NOTE: We use the same Chameleon instance for all envs, so we hardcode. In future, can move it to ENV.
        chameleon.init(
          "SAQyhV9hbnvfCGq0s1upkzFgbvaeUy0hXJRZ1EqH2x5WFQ-1UfjYK-FUVeP0nUbjoVidNp",
          { fastUrl: "https://fast.chameleon.io/" }
        );
      }

      chameleon.identify(userId, {
        // REQUIRED, the unique ID of each user in your database (e.g. 23443 or "690b80e5f433ea81b96c9bf6")/* chameleon.io user identification and data */
        // Example user properties; to use these replace the placeholders (e.g. USER.SIGN_UP_DATE) with your app’s actual variable names.
        email: user.email, // RECOMMENDED, email is used as the key to map user data for integrations
        name: user.displayName, // RECOMMENDED, name can be used to greet and/or personalize content
        current_org_id: currentOrgId,
        current_event_id: currentEventId,
        current_event_date_from: eventDetails?.date_from || null,
        current_event_date_to: eventDetails?.date_to || null,
        has_current_event_passed:
          eventDetails?.date_to && new Date() < new Date(eventDetails?.date_to)
            ? true
            : false,
        is_current_event_admin: isEventAdmin,
        is_any_event_admin: user?.event_roles?.some(r => r.is_admin),
        env: window.__ENV__,
        // created: user.created_at, // RECOMMENDED, must be ISO8601 or unix timestamp format (e.g. "2029-07-01T03:21:10Z" or 1431432000).
        // role: USER.ROLE, // OPTIONAL, properties such as ‘role’, ‘admin’, ‘membership’, etc. are useful for targeting types of users.
        // logins: USER.LOGIN_COUNT, // OPTIONAL, data about user engagement (e.g. 39).
        // project: USER.PROJECT_ID // OPTIONAL, any other unique data that might appear in any page URLs (e.g. 09876 or "12a34b56").
        company: {
          // REQUIRED FOR COMPANY DATA, For B2B products, send company / account information here.
          uid: orgId, // REQUIRED, Unique ID of the company / account in your database (e.g. 9832 or "690b80e5f433ea81b96c9bf7").
          // created: orgDetails.created_at, // RECOMMENDED, To enable targeting all users based on this company property.
          name: orgName // OPTIONAL, Send any data that appears within URLs, such as subdomains (e.g. "airbnb").
          // trial_ends: COMPANY.TRIAL_ENDS, // OPTIONAL, Send data about key milestones (e.g. "2029-08-01T03:21:10Z").
          // version: COMPANY.VERSION, // OPTIONAL, If your software varies by version then this will help show the correct guidance (e.g. "1.56").
          // plan: COMPANY.PLAN, // OPTIONAL, Send null when no value exists (e.g. "Gold", "Advanced").
          // spend: COMPANY.CLV // OPTIONAL, Send other properties that will help in targeting users (e.g. sales rep, source, stage).
        }
      });

      // window.Appcues.identify(userId, {
      //   env: window.__ENV__,
      //   email: user.email,
      //   first_name: user.fname,
      //   last_name: user.lname,
      //   name: user.displayName,
      //   current_org_id: currentOrgId,
      //   current_event_id: currentEventId
      // });

      if (currentOrgId) {
        // window.Appcues.group(
        //   currentOrgId, // unique, required
        //   {
        //     ...companyProperties
        //     // example custom group properties
        //     // createdAt: 1566932390, // Unix timestamp of account signup date
        //     // purchasedAt: 1566932395, // Unix timestamp of account purchase date
        //     // planTier: "Standard", // Account's plan tier
        //     // companyName: "CoolCo", // Account's name
        //     // MRR: 599, // Account's monthly recurring revenue
        //     // renewalDate: "06202035" // Timestamp of upcoming account renewal date
        //     // accountmanager: "Jerry" // Account manager
        //   }
        // );
      }
    }

    if (posthog && user) {
      // Identify sends an event, so you want may want to limit how often you call it
      posthog.identify(userId, {
        email: user.email,
        current_org_id: currentOrgId,
        current_event_id: currentEventId
      });

      if (currentOrgId) {
        let companyProperties;
        if (orgName) {
          companyProperties = {
            name: orgName
          };
        }
        posthog.group("company", currentOrgId, companyProperties);
      }
    }
  }, [posthog, user.id, user.email, currentOrgId, currentEventId]);

  return <>{children}</>;
}

export default ConfigureAnalytics;
